import React from "react";

const IncludedSection = ({
  mainImage,
  heading,
  items,
}) => {
  return (
    <section className="relative py-16 md:py-20 bg-[#F7F1EA] overflow-hidden">
      {/* BG GLOW */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#E7C9AB]/30 blur-3xl rounded-full" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#DDBA99]/20 blur-3xl rounded-full" />

      <div className="relative max-w-[1280px] mx-auto px-6">
        {/* HEADER */}
        <div className="text-center mb-12">
          <div
            className="
              inline-flex
              items-center
              px-4
              py-2
              rounded-full
              bg-[#FFF4E8]
              border
              border-[#F3DDC7]
              text-primary
              text-[11px]
              tracking-[.18em]
              uppercase
              font-medium
              mb-4
            "
          >
            In Your Package
          </div>

          <h2
            className="
              text-3xl
              md:text-5xl
              font-bold
              text-secondary
              leading-tight
            "
          >
            {heading}
          </h2>
        </div>

        {/* GRID */}
        <div
          className="
            grid
            grid-cols-1
            lg:grid-cols-2
            gap-8
            items-stretch
          "
        >
          {/* IMAGE */}
          <div
            className="
              group
              relative
              overflow-hidden
              rounded-[34px]
              min-h-[620px]
              shadow-[0_25px_60px_rgba(20,10,0,.10)]
            "
          >
            <img
              src={mainImage}
              alt="Main Retreat"
              className="
                w-full
                h-full
                object-cover
                transition-transform
                duration-700
                group-hover:scale-105
              "
            />

            <div
              className="
                absolute
                inset-0
                bg-gradient-to-t
                from-black/80
                via-black/20
                to-transparent
              "
            />

            {/* FLOATING CONTENT */}
            <div className="absolute bottom-6 left-6 right-6">
              <div
                className="
                  rounded-[28px]
                  bg-white/10
                  backdrop-blur-2xl
                  border
                  border-white/10
                  p-6
                "
              >
                <h3
                  className="
                    text-2xl
                    md:text-3xl
                    font-bold
                    text-white
                    mb-3
                  "
                >
                  Designed For Transformation
                </h3>

                <p
                  className="
                    text-white/75
                    text-sm
                    leading-7
                  "
                >
                  Every experience is carefully curated to help you reconnect
                  with your body, calm your mind, and create lasting inner
                  wellbeing.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              gap-4
            "
          >
            {items.map((item, index) => (
              <div
                key={index}
                className="
                  relative
                  overflow-hidden
                  rounded-[28px]
                  bg-white/75
                  backdrop-blur-xl
                  border
                  border-white/40
                  shadow-[0_15px_40px_rgba(20,10,0,.05)]
                  p-5
                  transition-all
                  duration-500
                  hover:-translate-y-1
                "
              >
                {/* GLOW */}
                <div
                  className="
                    absolute
                    top-0
                    right-0
                    w-32
                    h-32
                    bg-[#F4D8BE]/20
                    blur-3xl
                    rounded-full
                  "
                />

                <div className="relative z-10">
                  {/* ICON */}
                  <div
                    className="
                      w-12
                      h-12
                      rounded-full
                      bg-[#FFF4E8]
                      border
                      border-[#F3DDC7]
                      flex
                      items-center
                      justify-center
                      text-xl
                      mb-4
                    "
                  >
                    {item.icon}
                  </div>

                  {/* TITLE */}
                  <h3
                    className="
                      text-lg
                      md:text-xl
                      font-semibold
                      text-secondary
                      leading-snug
                      mb-3
                    "
                  >
                    {item.title}
                  </h3>

                  {/* DESCRIPTION */}
                  {item.description && (
                    <p
                      className="
                        text-[#5F5751]
                        text-sm
                        leading-7
                      "
                    >
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IncludedSection;